import { storyblokEditable } from "@storyblok/react";
import Image from "next/image";
import { sbBlok } from "@/types/sb-types";
import clsx from "clsx";

interface ImageComponentProps {
  blok: sbBlok;
}

const ImageComponent = ({ blok }: ImageComponentProps) => {
  const { image } = blok;

  return (
    <div
      className={clsx("grid-container", {
        "pt-7 lg:pt-14":
          !!blok.spacing_top?.length && blok.spacing_top[0].option === "large",
        "pt-14 lg:pt-[120px]":
          !!blok.spacing_top?.length &&
          blok.spacing_top[0].option === "x_large",
        "pt-[120px] lg:pt-[180px]":
          !!blok.spacing_top?.length &&
          blok.spacing_top[0].option === "xx_large",
        "pb-7 lg:pb-14":
          !!blok.spacing_bottom?.length &&
          blok.spacing_bottom[0].option === "large",
        "pb-14 lg:pb-[120px]":
          !!blok.spacing_bottom?.length &&
          blok.spacing_bottom[0].option === "x_large",
        "pb-[120px] lg:pb-[180px]":
          !!blok.spacing_bottom?.length &&
          blok.spacing_bottom[0].option === "xx_large",
      })}
    >
      <div className="col-start-1 col-span-4 row-start-1 lg:col-start-3 lg:col-span-12 2xl:col-start-9 2xl:col-span-16">
        <div
          {...storyblokEditable(blok)}
          className="relative w-full aspect-video rounded-[10px] overflow-hidden"
        >
          <Image
            src={image.filename}
            alt={image.alt}
            fill
            sizes="100vw"
            className="object-cover"
            quality={100}
          />
        </div>
      </div>
    </div>
  );
};

export default ImageComponent;
